<template>
	<div class="z-box-wrap">
		<ul class="head">
			<li :class="{active:activeIndex==0}" @click="activeIndex = 0">预算申请{{ `(${budget.total})` }}</li>
			<li :class="{active:activeIndex==1}" @click="activeIndex = 1">延期分配申请{{ `(${delay.total})` }}</li>
		</ul>
	
		<div class="main">
			<div class="tab-div" v-show="activeIndex == 0">
				<div class="search-head">
					<span>状态：</span>
					<el-select class="top-choose" v-model="budget.status" placeholder="请选择" @change="changeType('budget')">
						<el-option v-for="item in apply.statusOption" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="budget.date_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="budget.date_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<div class="front-btn green shift"  @click="budgetSearch()">查询</div>
				</div>

				<div class="list">
					<div class="list-head" :style="{'padding-right':padd_0}">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:budget.sort_str == 'createdAt_asc'}" @click="()=>{budget.sort_str='createdAt_asc'; budgetSearch()}"></i>
								<i class="el-icon-caret-bottom" :class="{active:budget.sort_str == 'createdAt_desc'}" @click="()=>{budget.sort_str='createdAt_desc'; budgetSearch()}"></i>
							</div>
						</div>
						<div>申请BU</div>
						<div>快币类型</div>
						<div>快币金额</div>
						<div v-show="budget.status !='1'">审核人</div>
						<div v-show="budget.status !='1'">审核时间</div>
						<div>状态</div>
						<div>操作</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in budget_list" :key="item.id">
							<div>{{ item.created_at }}</div>
							<div class="overhide" :title="item.bu_name">{{ item.bu_name }}</div>
							<div>{{ item.currency_name }}</div>
							<div>{{ item.trans_amount }}</div>
							<div v-show="budget.status !='1'" class="overhide" :title="item.real_name">{{ item.real_name }}</div>
							<div v-show="budget.status !='1'">{{ item.updated_at }}</div>
							<div :class="{danger:item.status==1}">{{ apply.statusObj[item.status] }}</div>
							<div @click="showSlider(item)" :class="{'orange-text':item.status == 1}">{{ item.status | applyStatus }}</div>
						</div>
						<z-noData :list="budget_list"></z-noData>
					</z-scrollDiv>	
				</div>

				<z-pagination class="inside" @getPage="budgetSearch" :data='budget.data'></z-pagination>
			</div>

			<div class="tab-div" v-show="activeIndex == 1">
				<div class="search-head">
					<span>状态：</span>
					<el-select class="top-choose" v-model="delay.status"  placeholder="请选择" @change="changeType('delay')">
						<el-option v-for="item in apply.statusOption" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="delay.date_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="delay.date_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<div class="front-btn green shift"  @click="delaySearch()">查询</div>
				</div>

				<div class="list">
					<div class="list-head" :style="{'padding-right':padd_1}">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:delay.sort_str == 'createdAt_asc'}" @click="()=>{delay.sort_str='createdAt_asc'; delaySearch()}"></i>
								<i class="el-icon-caret-bottom" :class="{active:delay.sort_str == 'createdAt_desc'}" @click="()=>{delay.sort_str='createdAt_desc'; delaySearch()}"></i>
							</div>
						</div>
						<div>申请BU</div>
						<div>申请周期</div>
						<div v-show="delay.status!='1'">审核人</div>
						<div v-show="delay.status!='1'">审核时间</div>
						<div>状态</div>
						<div>操作</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in delay_list" :key="item.id">
							<div>{{ item.created_at }}</div>
							<div class="overhide" :title="item.bu_name">{{ item.bu_name }}</div>
							<div>{{ item | cycleStr }}</div>
							<div v-show="delay.status!='1'" class="overhide" :title="item.real_name">{{ item.real_name }}</div>
							<div v-show="delay.status!='1'">{{ item.updated_at }}</div>
							<div :class="{danger:item.status==1}">{{ apply.statusObj[item.status] }}</div>
							<div @click="showSlider(item)" :class="{'orange-text':item.status == 1}">{{ item.status | applyStatus }}</div>
						</div>
						<z-noData :list="delay_list"></z-noData>
					</z-scrollDiv>	
				</div>

				<z-pagination class="inside" @getPage="delaySearch" :data='delay.data'></z-pagination>
			</div>
		</div>

		<!-- 滑页 -->
		<sliderPage :title="slider_Title" :sliderArg="sliderArg"  @close="sliderClear">
			<!-- 预算申请部分 -->
			<sliderBudget v-show="activeIndex == 0" :data="slider_data" :examine="sub" @pass="passSlider"  @notpass="notPassSlider"></sliderBudget>

			<div slot="pass" v-show="activeIndex == 0" class="form-wrap" v-form:slider-budget-num>
				<div class="form-item">
					<div class="item-title">充值BU：</div>
					<div class="item-text">{{ slider_data.bu_name }}</div>
				</div>
				<!-- <div class="form-item">
					<div class="item-title">快币类型：</div>
					<div class="item-text">{{ slider_data.currency_name }}</div>
				</div> -->
				<div class="form-item">
					<div class="item-title">申请金额：</div>
					<div class="item-text">{{ `${slider_data.trans_amount}${slider_data.currency_name}` }}</div>
				</div>
				<div class="form-item">
					<div class="item-title">充值金额：</div>
					<div class="item-text limit">
						<el-input v-tar="sub.yuan" rule="noVal number" v-model="sub.yuan" placeholder="请输入充值金额">
							<template slot="append">{{ slider_data.currency_name }}</template>
						</el-input>
					</div>
				</div>

				<div class="btns">
					<el-button @click="sliderArg.insideFlag = false">取 消</el-button>
					<el-button type="primary" @click="confirmBudget(slider_data.id)">确定</el-button>
				</div>
			</div>

			<!-- <div slot="notpass" v-show="activeIndex == 0" class="form-tip">
				<div class="text">是否确认提交处理结果</div>
				<div class="btns">
					<el-button @click="sliderArg.insideFlag = false">取 消</el-button>
					<el-button type="primary" @click="refuseBudget(slider_data.id)">确定</el-button>
				</div>
			</div> -->

			<!-- 延期申请部分 -->
			<sliderDelay v-show="activeIndex == 1" :data="slider_data" :examine="sub" @pass="passSlider"  @notpass="notPassSlider"></sliderDelay>


			<!-- 正常的分支处理 -->
			<div slot="pass" v-show="activeIndex != 0" class="form-tip">
				<div class="text">是否确认提交处理结果</div>
				<div class="btns">
					<el-button @click="sliderArg.insideFlag = false">取 消</el-button>
					<el-button type="primary" @click="confirmDelay(slider_data.id)">确定</el-button>
				</div>
			</div>

			<div slot="notpass" class="form-tip">
				<div class="text">是否确认提交处理结果</div>
				<div class="btns">
					<el-button @click="sliderArg.insideFlag = false">取 消</el-button>
					<el-button type="primary" v-show="activeIndex == 0" @click="refuseBudget(slider_data.id)">确定</el-button>
					<el-button type="primary" v-show="activeIndex == 1" @click="refuseDelay(slider_data.id)">确定</el-button>
				</div>
			</div>

			
		</sliderPage>
	</div>
</template>

<script>
	import sliderPage from "src/components/slider/sliderPage.vue"
	import sliderBudget from "src/components/slider/sliderBudget.vue"
	import sliderDelay from "src/components/slider/sliderDelay.vue"



	import { mapState } from "vuex";
	import { changeType } from 'src/control/common.js';  //公共方法

	export default {
		components: {
			sliderPage,
			sliderBudget,
			sliderDelay,
		},

		data() {
			return {
				activeIndex: 0,  //tab 序号
				sliderArg:{
					flag:false,
					inside_index:0,
					insideFlag:false,
				},
				slider_data:{},

				sub:{
					result:"",  //审核回复
					yuan:"",  //预算申请充值金额
				},

				budget:{   //预算申请的相关数据
					total:0,//预算申请数量
					data:{},  //预算申请数据
					status:"1",  //预算 状态
					date_start:"",  //预算 起始时间
					date_end:"",   //预算 终止时间
					sort_str:"createdAt_desc",  // 预算排序方式
				},

				delay:{
					total:0,//延期申请数量
					data:{},  //延期申请数据
					status:"1",  //延期 状态
					date_start:"",  //延期 起始时间
					date_end:"",   //延期 终止时间
					sort_str:"createdAt_desc",  // 延期排序方式
				},
			}
		},

		computed:{
			...mapState(["picker_special","apply"]),
			budget_list(){
				return this.budget.data.list;
			},
			delay_list(){
				return this.delay.data.list;
			},
			slider_Title(){
				return this.activeIndex==0?"预算申请":"延期分配申请";
			},
			padd_0(){
				return this.budget_list && this.budget_list.length>=8?"17px":0;
			},
			padd_1(){
				return this.delay_list && this.delay_list.length>=8?"17px":0;
			}, 
		},
		watch:{
			"sliderArg.flag"(val){
				if(val == false){
					this.slider_data = {};
				}
			}
		},

		created(){
			this.allFresh();
		},

		methods: {
			changeType,

			allFresh(){
				this.BudgetFresh();
				this.delayFresh();
			},
			showSlider(item){  //展示滑页
				this.sliderArg.flag = true; 
				this.slider_data = item;
			},
			sliderClear(){
				this.sub.result = "";
				this.sub.yuan = "";
				// this.$form.clear("slider-budget");
			},
			passSlider(){  //滑动
				this.sliderArg.inside_index = 0;
				this.sliderArg.insideFlag = true;
				this.sub.yuan = this.slider_data.trans_amount;
			},
			notPassSlider(){  //滑动
				this.sliderArg.inside_index = 1;
				this.sliderArg.insideFlag = true;
			},

			// **预算申请相关*****************
			BudgetFresh(obj = {},func){  //预算申请
				if(typeof obj == "function"){
					func = obj;
					obj = {};
				}

				let url = "api/admin/curr_bgt_req";
				this.$http.get(url,{params:obj}).then(res=>{
					if(res.status == 200){
						this.budget.data = res.res_data;
						if(this.budget.status == 1){
							this.budget.total = res.res_data.total;
						}
						func && func.apply(this);
					}
				});
			},
			budgetSearch(page,func){  //预算申请查询
				let obj = {
					page:page,
					status:this.budget.status,
					start_date:this.budget.date_start,
					end_date:this.budget.date_end,
					order_str:this.budget.sort_str,
				};
				this.BudgetFresh(obj,func);
			},
			confirmBudget(id){  //确认通过
				let res = this.$form.check("slider-budget-num");
				if(!res){
					return;
				}

				let url = `api/admin/curr_bgt_req/${id}/pass`;
				this.$http.put(url,{
					trans_amount:parseInt(this.sub.yuan),
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200 ){
						this.BudgetFresh();
						this.successTip("预算申请已通过");
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},
			refuseBudget(id){ //拒绝通过
				let url = `api/admin/curr_bgt_req/${id}/reject`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.successTip("预算申请已驳回");
						this.BudgetFresh();
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}

				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},


			// ***延期申请相关*****************
			delayFresh(obj = {},func){
				if(typeof obj == "function"){
					func = obj;
					obj = {};
				}
				let url = "api/admin/curr_trans_req_log";
				this.$http.get(url,{params:obj}).then(res=>{
					if(res.status == 200){
						this.delay.data = res.res_data;
						if(this.delay.status == 1){
							this.delay.total = res.res_data.total;
						}
						func && func.call(this,res.res_data);
					}
				});
			},
			delaySearch(page){  //延期申请查询
				let obj = {
					page:page,
					status:this.delay.status,
					start_date:this.delay.date_start,
					end_date:this.delay.date_end,
					created_at:this.delay.sort_str,
				};
				this.delayFresh(obj);
			},
			confirmDelay(id){  //通过延期申请
				let url = `api/admin/curr_trans_req_log/${id}/pass`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.delayFresh();
						this.successTip("预算申请已通过");
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},
			refuseDelay(id){   //拒绝延期申请
				let url = `api/admin/curr_trans_req_log/${id}/reject`;
				this.$http.put(url,{
					result:this.sub.result
				}).then(res=>{
					if(res.status == 200){
						this.delayFresh();
						this.successTip("预算申请已驳回");
						this.sliderArg.flag = false;
						this.sliderArg.insideFlag = false;
						this.sliderClear();
					}
				}).catch(error=>{
					this.errorTip("操作失败");
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	// @import "~src/assets/less/var.less";
	@import "~src/assets/less/application.less";

	.list-head >div,.list-detail .item>div{
        &:nth-of-type(1){
            width: 15%;
        }
        &:nth-of-type(2){
			width: 10%;
        }
        &:nth-of-type(3){
            width: 10%;
		}
		&:nth-of-type(4){
            width: 10%;
        }
        &:nth-of-type(5){
			width: 10%;
        }
        &:nth-of-type(6){
            width: 15%;
		}
		&:nth-of-type(7){
            width: 10%;
		}
		&:nth-of-type(8){
            width: 10%;
		}
	}

	.list-detail .item>div{
		&:last-child{
			color: @focus-c;
			cursor:pointer;
		}
	}

	.tab-div:nth-child(2){
		.list-head >div,.list-detail .item>div{
			&:nth-of-type(5){
				width: 15%;
			}
			&:nth-of-type(6){
				width: 10%;
			}
			&:nth-of-type(7){
				width: 10%;
			}
		}
	}

	.danger{
		color: @red;
	}
</style>





// WEBPACK FOOTER //
// page-finance-examine.vue?2aeb8f76